import { epic$, store } from '@redux/store';
import setupNativeInteractiveSiteMap from 'features/nativeInteractiveSiteMap';
import uiStateSlice from 'layout/redux/uiStateSlice';
import {
  configurationSlice,
  CONFIGURATION_SLICE_KEY,
  getConfigurationEpic,
  createMapLibrarySlice,
  MAP_LIBRARY_SLICE_KEY
} from 'layout/redux';

epic$.next(getConfigurationEpic);

store.injectReducer(CONFIGURATION_SLICE_KEY, configurationSlice.reducer);
store.dispatch(configurationSlice.actions.fetchConfiguration());

const communityDetailElement = document.querySelector("[data-component='community-detail-data']");
const communityDetailData = communityDetailElement?.innerHTML
  ? JSON.parse(communityDetailElement.innerHTML)
  : {};

if (communityDetailData?.hasSelfGuidedTour) {
  require('./components/selfGuidedWidget');
}

if (communityDetailData?.hasInteractiveSiteMap) {
  store.injectReducer('uiState', uiStateSlice.reducer);
  const mapLibrarySlice = createMapLibrarySlice();
  store.injectReducer(MAP_LIBRARY_SLICE_KEY, mapLibrarySlice.reducer);
  require('layout/components/modal');
  require('layout/components/drawer');
  require('layout/components/responsiveLayoutHandler');
  require('features/leadGenerators').setupLeadGenerators();
  setupNativeInteractiveSiteMap({
    communityId: communityDetailData.communityId ?? null,
    communityName: communityDetailData.communityName ?? null,
    marketId: communityDetailData.marketId ?? null,
    marketName: communityDetailData.marketName ?? null,
    brandName: communityDetailData.brandName ?? null,
    latitude: communityDetailData.latitude ?? null,
    longitude: communityDetailData.longitude ?? null,
    mapLibrarySlice,
  });
}

require('features/segment');
require('./components/eventTracking/segmentEventsHandler');
require('features/googleAnalytics4');
require('./components/eventTracking/googleAnalytics4EventsHandler');